import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Lazy-loaded, cached for the tab's lifetime. Open-source FingerprintJS —
// a device/browser signal for bot & duplicate-lead detection, not identity
// tracking. Never blocks a submission if it fails; always resolves.
let fpPromise = null;

export async function getVisitorFingerprint() {
  try {
    if (!fpPromise) {
      fpPromise = FingerprintJS.load();
    }
    const fp = await fpPromise;
    const result = await fp.get();
    return result.visitorId;
  } catch {
    return null; // never let a fingerprint failure block a lead submission
  }
}
